// WLP Adoption — i18n (B3.1, Feb 2026)
//
// Generic EN/ES copy (no profile_key segmentation in v1).
// Remaining 11 active languages fall back to EN — this is a deliberate
// scope decision; segmentation per profile_key is v2 if conversion is low.

const pick = (m, lang) => m[lang] ?? m.en;

const _COPY = (lang) => ({
  // Modal
  modalHeading: pick({
    en: "Help shape what TEAM brings to your sport",
    es: "Ayúdanos a moldear lo que TEAM trae a tu deporte",
    ca: "Ajuda a donar forma al que TEAM porta al teu esport",
    eu: "Lagundu TEAMek zure kirolera zer ekartzen duen zehaztzen",
    gl: "Axuda a dar forma ao que TEAM achega ao teu deporte",
    ar: "ساعد في تشكيل ما يقدمه TEAM لرياضتك",
    he: "עזרו לנו לעצב את מה ש-TEAM מביא לספורט שלכם",
    zh: "帮助塑造 TEAM 为您的运动带来的价值",
    it: "Contribuisci a plasmare ciò che TEAM porta al tuo sport",
    fr: "Aidez à façonner ce que TEAM apporte à votre sport",
    de: "Helfen Sie mit, was TEAM für Ihren Sport bringt",
    "pt-br": "Ajude a moldar o que o TEAM traz para o seu esporte",
    ja: "TEAMがあなたのスポーツにもたらすものを形作るお手伝いを",
    hi: "TEAM आपके खेल में क्या लाए, इसे आकार देने में मदद करें",
    ko: "TEAM이 귀하의 스포츠에 제공할 내용을 함께 만들어 가세요",
    ru: "Помогите сформировать то, что TEAM предлагает вашему виду спорта",
    cs: "Pomozte formovat, co TEAM přináší vašemu sportu",
    nl: "Help vorm te geven aan wat TEAM naar jouw sport brengt",
  }, lang),
  modalBody: pick({
    en: "In under a minute, tell us your favourite brands, the gear & services you want, and the sponsorship categories you'd love to see. We use this only as anonymous, aggregated data to spot what the community needs — your identity stays private.",
    es: "En menos de un minuto, cuéntanos tus marcas favoritas, los productos y servicios que quieres y las categorías de patrocinio que te interesan. Usamos esto solo como dato anónimo y agregado para entender qué necesita la comunidad — tu identidad permanece privada.",
    ca: "En menys d'un minut, explica'ns les teves marques favorites, l'equipament i serveis que vols, i les categories de patrocini que t'agradaria veure. Utilitzem això només com a dades anònimes i agregades per detectar què necessita la comunitat — la teva identitat es manté privada.",
    eu: "Minutu bat baino gutxiagotan, esan iezaguzu zure marka gogokoenak, nahi dituzun ekipamendua eta zerbitzuak, eta ikusi nahiko zenituzke babesle-kategoriak. Hau datu anonimo eta agregatuak gisa soilik erabiltzen dugu komunitateak behar duena antzemateko — zure identitatea pribatua izaten jarraitzen du.",
    gl: "En menos dun minuto, dinos as túas marcas favoritas, o equipamento e servizos que queres, e as categorías de patrocinio que che gustaría ver. Usamos isto só como datos anónimos e agregados para detectar o que necesita a comunidade — a túa identidade permanece privada.",
    ar: "في أقل من دقيقة، أخبرنا عن علاماتك التجارية المفضلة، والمعدات والخدمات التي تريدها، وفئات الرعاية التي تود رؤيتها. نستخدم هذا فقط كبيانات مجمعة مجهولة المصدر لتحديد ما يحتاجه المجتمع — تظل هويتك خاصة.",
    he: "בפחות מדקה, ספרו לנו מהם המותגים האהובים עליכם, הציוד והשירותים שאתם רוצים, וקטגוריות החסויות שתשמחו לראות. אנו משתמשים בזה רק כנתונים אנונימיים ומצטברים כדי לזהות מה הקהילה צריכה — הזהות שלכם נשארת פרטית.",
    zh: "只需不到一分钟，告诉我们您喜爱的品牌、想要的装备和服务，以及您希望看到的赞助类别。我们仅将其作为匿名汇总数据使用，以发现社区需求——您的身份保持私密。",
    it: "In meno di un minuto, dicci i tuoi brand preferiti, l'attrezzatura e i servizi che desideri e le categorie di sponsorizzazione che vorresti vedere. Utilizziamo questi dati solo in forma anonima e aggregata per individuare ciò di cui la community ha bisogno — la tua identità rimane privata.",
    fr: "En moins d'une minute, indiquez-nous vos marques préférées, l'équipement et les services que vous souhaitez, ainsi que les catégories de partenariat que vous aimeriez voir. Nous utilisons ces données uniquement de manière anonyme et agrégée pour identifier les besoins de la communauté — votre identité reste privée.",
    de: "Teilen Sie uns in unter einer Minute Ihre Lieblingsmarken, die Ausrüstung & Services, die Sie wünschen, und die Sponsoring-Kategorien mit, die Sie gerne sehen würden. Wir nutzen dies nur als anonyme, aggregierte Daten, um zu erkennen, was die Community braucht – Ihre Identität bleibt privat.",
    "pt-br": "Em menos de um minuto, conte-nos suas marcas favoritas, os equipamentos e serviços que você deseja e as categorias de patrocínio que adoraria ver. Usamos isso apenas como dados anônimos e agregados para identificar o que a comunidade precisa — sua identidade permanece privada.",
    ja: "1分以内に、お気に入りのブランド、欲しい用品・サービス、見てみたいスポンサーカテゴリーを教えてください。この情報は匿名で集約されたデータとしてのみ使用され、コミュニティが必要とするものを把握します。あなたの個人情報は非公開のままです。",
    hi: "एक मिनट से भी कम समय में, हमें अपने पसंदीदा ब्रांड, वह गियर और सेवाएं जो आप चाहते हैं, और वे प्रायोजन श्रेणियां बताएं जो आप देखना पसंद करेंगे। हम इसका उपयोग केवल गुमनाम, समेकित डेटा के रूप में करते हैं ताकि समुदाय की जरूरतों को समझा जा सके — आपकी पहचान निजी रहती है।",
    ko: "1분도 안 되는 시간에 선호하는 브랜드, 원하는 장비 및 서비스, 그리고 보고 싶은 후원 카테고리를 알려주세요. 이 정보는 익명화되고 집계된 데이터로만 사용되어 커뮤니티가 필요로 하는 것을 파악하는 데 활용됩니다. 귀하의 신원은 비공개로 유지됩니다.",
    ru: "Менее чем за минуту расскажите нам о ваших любимых брендах, товарах и услугах, которые вы хотите, и категориях спонсорства, которые вы хотели бы видеть. Мы используем это только как анонимные, агрегированные данные для определения потребностей сообщества — ваша личность остаётся конфиденциальной.",
    cs: "Za necelou minutu nám řekněte své oblíbené značky, vybavení a služby, které chcete, a kategorie sponzorství, které byste rádi viděli. Používáme to pouze jako anonymní, agregovaná data ke zjištění, co komunita potřebuje — vaše identita zůstává soukromá.",
    nl: "Vertel ons in minder dan een minuut je favoriete merken, de uitrusting & diensten die je wilt, en de sponsorcategorieën die je graag zou zien. We gebruiken dit alleen als anonieme, geaggregeerde data om te ontdekken wat de gemeenschap nodig heeft — jouw identiteit blijft privé.",
  }, lang),
  modalCtaPrimary: pick({
    en: "Set up my wishlist · 60s",
    es: "Configurar mi wishlist · 60s",
    ca: "Configura la meva llista de desitjos · 60s",
    eu: "Konfiguratu nire desio-zerrenda · 60s",
    gl: "Configurar a miña lista de desexos · 60s",
    ar: "إعداد قائمة رغباتي · 60 ثانية",
    he: "הגדרת רשימת המשאלות שלי · 60 שניות",
    zh: "设置我的心愿单 · 60秒",
    it: "Configura la mia wishlist · 60s",
    fr: "Configurer ma liste de souhaits · 60s",
    de: "Meine Wunschliste einrichten · 60 Sek.",
    "pt-br": "Configurar minha lista de desejos · 60s",
    ja: "ウィッシュリストを設定 · 60秒",
    hi: "मेरी विशलिस्ट सेट करें · 60 सेकंड",
    ko: "위시리스트 설정 · 60초",
    ru: "Настроить мой список желаний · 60 сек",
    cs: "Nastavit můj seznam přání · 60s",
    nl: "Stel mijn verlanglijst in · 60s",
  }, lang),
  modalCtaSecondary: pick({
    en: "Maybe later",
    es: "Quizás más tarde",
    ca: "Potser més tard",
    eu: "Agian geroago",
    gl: "Quizais máis tarde",
    ar: "ربما لاحقاً",
    he: "אולי מאוחר יותר",
    zh: "稍后再说",
    it: "Forse più tardi",
    fr: "Plus tard",
    de: "Vielleicht später",
    "pt-br": "Talvez mais tarde",
    ja: "後で",
    hi: "शायद बाद में",
    ko: "나중에 하기",
    ru: "Может быть, позже",
    cs: "Možná později",
    nl: "Misschien later",
  }, lang),
  // Banner (passive, in /app/settings)
  bannerSparkle: "✨",
  bannerText: pick({
    en: "Your wishlist preferences are empty. Tell us what you want and help shape TEAM for your community.",
    es: "Tus preferencias de wishlist están vacías. Cuéntanos qué quieres y ayuda a moldear TEAM para tu comunidad.",
    ca: "Les teves preferències de la llista de desitjos estan buides. Digues-nos què vols i ajuda a donar forma a TEAM per a la teva comunitat.",
    eu: "Zure desio-zerrendako lehentasunak hutsik daude. Esan iezaguzu zer nahi duzun eta lagundu TEAM zure komunitatearentzat moldatzen.",
    gl: "As túas preferencias da lista de desexos están baleiras. Dinos o que queres e axuda a dar forma a TEAM para a túa comunidade.",
    ar: "تفضيلات قائمة رغباتك فارغة. أخبرنا بما تريد وساعد في تشكيل TEAM لمجتمعك.",
    he: "העדפות רשימת המשאלות שלכם ריקות. ספרו לנו מה אתם רוצים ועזרו לעצב את TEAM עבור הקהילה שלכם.",
    zh: "您的心愿单偏好为空。告诉我们您想要什么，帮助为您的社区塑造 TEAM。",
    it: "Le tue preferenze della wishlist sono vuote. Dicci cosa desideri e aiutaci a plasmare TEAM per la tua community.",
    fr: "Vos préférences de liste de souhaits sont vides. Dites-nous ce que vous voulez et aidez à façonner TEAM pour votre communauté.",
    de: "Ihre Wunschlisten-Präferenzen sind leer. Sagen Sie uns, was Sie möchten, und helfen Sie mit, TEAM für Ihre Community zu gestalten.",
    "pt-br": "Suas preferências da lista de desejos estão vazias. Conte-nos o que você quer e ajude a moldar o TEAM para sua comunidade.",
    ja: "ウィッシュリストの設定が空です。欲しいものを教えて、コミュニティのためにTEAMを形作るお手伝いをしてください。",
    hi: "आपकी विशलिस्ट प्राथमिकताएं खाली हैं। हमें बताएं कि आप क्या चाहते हैं और अपने समुदाय के लिए TEAM को आकार देने में मदद करें।",
    ko: "위시리스트 설정이 비어 있습니다. 원하는 것을 알려주시고 커뮤니티를 위한 TEAM을 함께 만들어 가세요.",
    ru: "Ваши предпочтения в списке желаний пусты. Расскажите нам, что вы хотите, и помогите сформировать TEAM для вашего сообщества.",
    cs: "Vaše preference seznamu přání jsou prázdné. Řekněte nám, co chcete, a pomozte formovat TEAM pro vaši komunitu.",
    nl: "Je verlanglijstvoorkeuren zijn leeg. Vertel ons wat je wilt en help TEAM vorm te geven voor jouw gemeenschap.",
  }, lang),
  bannerTagline: pick({
    en: "Anonymous · aggregated · private.",
    es: "Anónimo · agregado · privado.",
    ca: "Anònim · agregat · privat.",
    eu: "Anonimoa · agregatua · pribatua.",
    gl: "Anónimo · agregado · privado.",
    ar: "مجهول · مجمّع · خاص.",
    he: "אנונימי · מצטבר · פרטי.",
    zh: "匿名 · 汇总 · 私密。",
    it: "Anonimo · aggregato · privato.",
    fr: "Anonyme · agrégé · privé.",
    de: "Anonym · aggregiert · privat.",
    "pt-br": "Anônimo · agregado · privado.",
    ja: "匿名 · 集約 · 非公開。",
    hi: "गुमनाम · समेकित · निजी।",
    ko: "익명 · 집계 · 비공개",
    ru: "Анонимно · агрегировано · конфиденциально.",
    cs: "Anonymní · agregované · soukromé.",
    nl: "Anoniem · geaggregeerd · privé.",
  }, lang),
  bannerCta: pick({
    en: "Complete now",
    es: "Completar ahora",
    ca: "Completa ara",
    eu: "Osatu orain",
    gl: "Completar agora",
    ar: "أكمل الآن",
    he: "השלימו עכשיו",
    zh: "立即完成",
    it: "Completa ora",
    fr: "Compléter maintenant",
    de: "Jetzt vervollständigen",
    "pt-br": "Completar agora",
    ja: "今すぐ完了",
    hi: "अभी पूर्ण करें",
    ko: "지금 완료하기",
    ru: "Заполнить сейчас",
    cs: "Dokončit nyní",
    nl: "Voltooi nu",
  }, lang),
  // Privacy block (always visible inside modal)
  privacyHeading: pick({
    en: "Your privacy",
    es: "Tu privacidad",
    ca: "La teva privacitat",
    eu: "Zure pribatutasuna",
    gl: "A túa privacidade",
    ar: "خصوصيتك",
    he: "הפרטיות שלכם",
    zh: "您的隐私",
    it: "La tua privacy",
    fr: "Votre confidentialité",
    de: "Ihre Privatsphäre",
    "pt-br": "Sua privacidade",
    ja: "プライバシーについて",
    hi: "आपकी गोपनीयता",
    ko: "개인정보 보호",
    ru: "Ваша конфиденциальность",
    cs: "Vaše soukromí",
    nl: "Jouw privacy",
  }, lang),
  privacyBody: pick({
    en: "Phase 1 uses aggregate counts with K-anonymity (≥5 users). No individual identity is shared. Minors are excluded. Sponsors do not see your contact information.",
    es: "Fase 1 usa conteos agregados con K-anonimato (≥5 usuarios). No se comparte identidad individual. Menores excluidos. Los patrocinadores no ven tu información de contacto.",
    ca: "La fase 1 utilitza recomptes agregats amb K-anonimat (≥5 usuaris). No es comparteix cap identitat individual. Els menors queden exclosos. Els patrocinadors no veuen la teva informació de contacte.",
    eu: "1. faseak zenbaketa agregatuak erabiltzen ditu K-anonimotasunarekin (≥5 erabiltzaile). Ez da banakako identitaterik partekatzen. Adingabeak kanpoan gelditzen dira. Babesleak ez dute zure harremanetarako informazioa ikusten.",
    gl: "A fase 1 usa reconto agregado con K-anonimato (≥5 usuarios). Non se comparte ningunha identidade individual. Exclúense os menores. Os patrocinadores non ven a túa información de contacto.",
    ar: "تستخدم المرحلة الأولى إحصاءات مجمعة مع إخفاء الهوية (≥5 مستخدمين). لا تتم مشاركة أي هوية فردية. يُستثنى القاصرون. لا يرى الرعاة معلومات الاتصال الخاصة بك.",
    he: "שלב 1 משתמש בספירות מצטברות עם K-אנונימיות (≥5 משתמשים). לא משותפת זהות אישית. קטינים לא נכללים. נותני חסות לא רואים את פרטי הקשר שלכם.",
    zh: "第一阶段使用 K-匿名性（≥5 位用户）的汇总计数。不会共享任何个人身份信息。未成年人被排除在外。赞助商无法看到您的联系信息。",
    it: "La Fase 1 utilizza conteggi aggregati con K-anonymity (≥5 utenti). Nessuna identità individuale viene condivisa. I minori sono esclusi. Gli sponsor non vedono le tue informazioni di contatto.",
    fr: "La Phase 1 utilise des données agrégées avec K-anonymat (≥5 utilisateurs). Aucune identité individuelle n'est partagée. Les mineurs sont exclus. Les partenaires ne voient pas vos coordonnées.",
    de: "Phase 1 verwendet aggregierte Zählungen mit K-Anonymität (≥5 Nutzer). Keine individuelle Identität wird weitergegeben. Minderjährige sind ausgeschlossen. Sponsoren sehen Ihre Kontaktinformationen nicht.",
    "pt-br": "A Fase 1 usa contagens agregadas com K-anonimato (≥5 usuários). Nenhuma identidade individual é compartilhada. Menores são excluídos. Os patrocinadores não veem suas informações de contato.",
    ja: "フェーズ1では、K匿名性(≥5ユーザー)による集約カウントを使用します。個人の身元は共有されません。未成年者は除外されます。スポンサーはあなたの連絡先情報を見ることはできません。",
    hi: "चरण 1 में K-गुमनामीकरण (≥5 उपयोगकर्ता) के साथ समेकित गणना का उपयोग होता है। कोई व्यक्तिगत पहचान साझा नहीं की जाती। नाबालिगों को बाहर रखा गया है। प्रायोजक आपकी संपर्क जानकारी नहीं देखते।",
    ko: "1단계에서는 K-익명성(5명 이상의 사용자)을 적용한 집계 데이터를 사용합니다. 개인 신원 정보는 공유되지 않습니다. 미성년자는 제외됩니다. 후원사는 귀하의 연락처 정보를 볼 수 없습니다.",
    ru: "Фаза 1 использует агрегированные подсчёты с K-анонимностью (≥5 пользователей). Никакая индивидуальная информация не передаётся. Несовершеннолетние исключены. Спонсоры не видят вашу контактную информацию.",
    cs: "Fáze 1 používá agregované počty s K-anonymitou (≥5 uživatelů). Žádná individuální identita není sdílena. Nezletilí jsou vyloučeni. Sponzoři nevidí vaše kontaktní údaje.",
    nl: "Fase 1 gebruikt geaggregeerde tellingen met K-anonimiteit (≥5 gebruikers). Geen individuele identiteit wordt gedeeld. Minderjarigen zijn uitgesloten. Sponsors zien je contactgegevens niet.",
  }, lang),
});

const LANGS = ["en", "es", "zh", "it", "fr", "de", "pt-br", "ja", "hi", "ko", "ru", "cs", "nl", "ca", "eu", "gl", "ar", "he"];
export const WLP_ADOPTION_I18N = Object.fromEntries(LANGS.map((l) => [l, _COPY(l)]));
